<script setup lang="ts">
import { computed, ref } from 'vue'
import MmMenu from '../base/MmMenu.vue'
import MmIconButton from '../base/MmIconButton.vue'
import type { MmMenuItem } from '../base/menu'
const props = defineProps<{ title: string; resumeLabel: string; isPublic: boolean }>()
const emit = defineEmits<{ resume: []; share: [] }>()
const { t } = useI18n()
const open = ref(false)
const items = computed<MmMenuItem[]>(() => [
  { head: props.title },
  { id: 'resume', label: props.resumeLabel },
  ...(props.isPublic ? [{ id: 'share', label: t('clips.tasks.actions.view_share') }] : []),
])
</script>

<template>
  <MmMenu v-model="open" :label="t('mm.moreFor', { title })" :items="items" @select="item => item.id === 'share' ? emit('share') : emit('resume')">
    <template #trigger="{ toggle, expanded, id }">
      <MmIconButton icon="more" :label="t('mm.moreFor', { title })" aria-haspopup="menu" :aria-expanded="expanded" :aria-controls="id" @click="toggle" />
    </template>
  </MmMenu>
</template>
